// Avatar mapping based on assessment combinations
// Format: depression-anxiety-stress-brs-ciss -> avatar name

// Convert assessment levels to standardized format
export const standardizeLevels = {
  dass: {
    '正常': 'normal-mild',
    '輕微': 'normal-mild',
    '中度': 'moderate',
    '嚴重': 'severe-extremely-severe',
    '極度嚴重': 'severe-extremely-severe'
  },
  brs: {
    '低': 'low',
    '中度': 'moderate',
    '高': 'high'
  }
};

// Helper function to get avatar name based on assessment results
export const getAvatarName = (
  depression: string,
  anxiety: string,
  stress: string,
  brs: string,
  ciss: 'task' | 'emotion' | 'avoidance'
): string => {
  // Standardize DASS levels
  const depLevel = standardizeLevels.dass[depression] || 'normal-mild';
  const anxLevel = standardizeLevels.dass[anxiety] || 'normal-mild';
  const strLevel = standardizeLevels.dass[stress] || 'normal-mild';
  
  // Standardize BRS level
  const brsLevel = standardizeLevels.brs[brs] || 'moderate';

  // Generate mapping key
  const key = `${depLevel}-${anxLevel}-${strLevel}-${brsLevel}-${ciss}`;
  
  // Map combinations to avatar names
  const mappings: Record<string, string> = {
'normal-mild-normal-mild-normal-mild-low-task':'Serene Way',
'normal-mild-normal-mild-normal-mild-low-emotional':'Radiant Refuge',
'normal-mild-normal-mild-normal-mild-low-avoidance':'Gentle Journey',
'normal-mild-normal-mild-normal-mild-moderate-task':'Whisper Meadow',
'normal-mild-normal-mild-normal-mild-moderate-emotional':'Calm Resilience',
'normal-mild-normal-mild-normal-mild-moderate-avoidance':'Healing Lighthouse',
'normal-mild-normal-mild-normal-mild-high-task':'Luna Sanctuary',
'normal-mild-normal-mild-normal-mild-high-emotional':'Inner Oasis',
'normal-mild-normal-mild-normal-mild-high-avoidance':'Reflective Stream',
'normal-mild-normal-mild-moderate-low-task':'Hopeful Ascent',
'normal-mild-normal-mild-moderate-low-emotional':'Peaceful Nest',
'normal-mild-normal-mild-moderate-low-avoidance':'Spirit Anchor',
'normal-mild-normal-mild-moderate-moderate-task':'Mindful Retreat',
'normal-mild-normal-mild-moderate-moderate-emotional':'Dream Grove',
'normal-mild-normal-mild-moderate-moderate-avoidance':'Shade Blossom',
'normal-mild-normal-mild-moderate-high-task':'Balanced Hills',
'normal-mild-normal-mild-moderate-high-emotional':'Harmony Cove',
'normal-mild-normal-mild-moderate-high-avoidance':'Sanctuary Skies',
'normal-mild-normal-mild-severe-extremely-severe-low-task':'Restorative Spark',
'normal-mild-normal-mild-severe-extremely-severe-low-emotional':'Safe Passage',
'normal-mild-normal-mild-severe-extremely-severe-low-avoidance':'Cozy Hues',
'normal-mild-normal-mild-severe-extremely-severe-moderate-task':'Inner Compass',
'normal-mild-normal-mild-severe-extremely-severe-moderate-emotional':'Quiet Harbor',
'normal-mild-normal-mild-severe-extremely-severe-moderate-avoidance':'Mind Blossom',
'normal-mild-normal-mild-severe-extremely-severe-high-task':'Lighthouse Grace',
'normal-mild-normal-mild-severe-extremely-severe-high-emotional':'Easeful Haven',
'normal-mild-normal-mild-severe-extremely-severe-high-avoidance':'Tranquility Path',
'normal-mild-moderate-normal-mild-low-task':'Solstice Sky',
'normal-mild-moderate-normal-mild-low-emotional':'Steady Shore',
'normal-mild-moderate-normal-mild-low-avoidance':'Shothe Glade',
'normal-mild-moderate-normal-mild-moderate-task':'Steady Willow',
'normal-mild-moderate-normal-mild-moderate-emotional':'Seek Hope',
'normal-mild-moderate-normal-mild-moderate-avoidance':'Harboring Calm',
'normal-mild-moderate-normal-mild-high-task':'Haven Bloom',
'normal-mild-moderate-normal-mild-high-emotional':'Shelter Room',
'normal-mild-moderate-normal-mild-high-avoidance':'Heart’s Refuge',
'normal-mild-moderate-moderate-low-task':'Embolden Rise',
'normal-mild-moderate-moderate-low-emotional':'Gentle Seascape',
'normal-mild-moderate-moderate-low-avoidance':'Warm Serenity',
'normal-mild-moderate-moderate-moderate-task':'Enchanted Hearth',
'normal-mild-moderate-moderate-moderate-emotional':'Uphold Sanctuary',
'normal-mild-moderate-moderate-moderate-avoidance':'Tranquility Wind',
'normal-mild-moderate-moderate-high-task':'Lantern’s Glow',
'normal-mild-moderate-moderate-high-emotional':'Spirit Oasis',
'normal-mild-moderate-moderate-high-avoidance':'Cherish Vale',
'normal-mild-moderate-severe-extremely-severe-low-task':'Mindful Horizon',
'normal-mild-moderate-severe-extremely-severe-low-emotional':'Sunset Crimson',
'normal-mild-moderate-severe-extremely-severe-low-avoidance':'Calm Canvas',
'normal-mild-moderate-severe-extremely-severe-moderate-task':'Flourish Morn',
'normal-mild-moderate-severe-extremely-severe-moderate-emotional':'Sheltering Light',
'normal-mild-moderate-severe-extremely-severe-moderate-avoidance':'Thought Harbor',
'normal-mild-moderate-severe-extremely-severe-high-task':'Driftwood Rest',
'normal-mild-moderate-severe-extremely-severe-high-emotional':'Inner Peace',
'normal-mild-moderate-severe-extremely-severe-high-avoidance':'Rising Petals',
'normal-mild-severe-extremely-severe-normal-mild-low-task':'Meadow Mind',
'normal-mild-severe-extremely-severe-normal-mild-low-emotional':'Healing Crest',
'normal-mild-severe-extremely-severe-normal-mild-low-avoidance':'Beacon’s End',
'normal-mild-severe-extremely-severe-normal-mild-moderate-task':'Breath of Bliss',
'normal-mild-severe-extremely-severe-normal-mild-moderate-emotional':'Solace Pines',
'normal-mild-severe-extremely-severe-normal-mild-moderate-avoidance':'Joyful Summit',
'normal-mild-severe-extremely-severe-normal-mild-high-task':'Comfort Harbor',
'normal-mild-severe-extremely-severe-normal-mild-high-emotional':'Vita Haven',
'normal-mild-severe-extremely-severe-normal-mild-high-avoidance':'Eims Dream',
'normal-mild-severe-extremely-severe-moderate-low-task':'Nature Sanctuary',
'normal-mild-severe-extremely-severe-moderate-low-emotional':'Tranquil Birch',
'normal-mild-severe-extremely-severe-moderate-low-avoidance':'Reflection Bloom',
'normal-mild-severe-extremely-severe-moderate-moderate-task':'Harbor Heart',
'normal-mild-severe-extremely-severe-moderate-moderate-emotional':'Brighter Path',
'normal-mild-severe-extremely-severe-moderate-moderate-avoidance':'Refuge Ridge',
'normal-mild-severe-extremely-severe-moderate-high-task':'Illume Glade',
'normal-mild-severe-extremely-severe-moderate-high-emotional':'Presence Haven',
'normal-mild-severe-extremely-severe-moderate-high-avoidance':'Insight Glimmer',
'normal-mild-severe-extremely-severe-severe-extremely-severe-low-task':'Haven Quest',
'normal-mild-severe-extremely-severe-severe-extremely-severe-low-emotional':'Soulful Wave',
'normal-mild-severe-extremely-severe-severe-extremely-severe-low-avoidance':'Shelter Mist',
'normal-mild-severe-extremely-severe-severe-extremely-severe-moderate-task':'Willowdale',
'normal-mild-severe-extremely-severe-severe-extremely-severe-moderate-emotional':'Healing Horizon',
'normal-mild-severe-extremely-severe-severe-extremely-severe-moderate-avoidance':'Quiet Haven',
'normal-mild-severe-extremely-severe-severe-extremely-severe-high-task':'Hearthfire Path',
'normal-mild-severe-extremely-severe-severe-extremely-severe-high-emotional':'Harmony Cloak',
'normal-mild-severe-extremely-severe-severe-extremely-severe-high-avoidance':'Freeusof Ease',
'moderate-normal-mild-normal-mild-low-task':'Grace Helm',
'moderate-normal-mild-normal-mild-low-emotional':'Awakening Tide',
'moderate-normal-mild-normal-mild-low-avoidance':'Gentle Helm',
'moderate-normal-mild-normal-mild-moderate-task':'Renew Haven',
'moderate-normal-mild-normal-mild-moderate-emotional':'Embrace Meadow',
'moderate-normal-mild-normal-mild-moderate-avoidance':'Peace Tides',
'moderate-normal-mild-normal-mild-high-task':'Calm Shore',
'moderate-normal-mild-normal-mild-high-emotional':'Golden Haven',
'moderate-normal-mild-normal-mild-high-avoidance':'Mystic Harbor',
'moderate-normal-mild-moderate-low-task':'Serenity Bloom',
'moderate-normal-mild-moderate-low-emotional':'Ocean Grace',
'moderate-normal-mild-moderate-low-avoidance':'Harmony Path',
'moderate-normal-mild-moderate-moderate-task':'Bright Refuge',
'moderate-normal-mild-moderate-moderate-emotional':'Tranquil Mesa',
'moderate-normal-mild-moderate-moderate-avoidance':'Fallen Leaves',
'moderate-normal-mild-moderate-high-task':'Blissful Glade',
'moderate-normal-mild-moderate-high-emotional':'Morning Solace',
'moderate-normal-mild-moderate-high-avoidance':'Echoing Stream',
'moderate-normal-mild-severe-extremely-severe-low-task':'Kindred Spirit',
'moderate-normal-mild-severe-extremely-severe-low-emotional':'Sacred Haven',
'moderate-normal-mild-severe-extremely-severe-low-avoidance':'Windsong Cove',
'moderate-normal-mild-severe-extremely-severe-moderate-task':'Whispering Pines',
'moderate-normal-mild-severe-extremely-severe-moderate-emotional':'Stillwater Shore',
'moderate-normal-mild-severe-extremely-severe-moderate-avoidance':'Radiant Horizon',
'moderate-normal-mild-severe-extremely-severe-high-task':'Peaceful Ascent',
'moderate-normal-mild-severe-extremely-severe-high-emotional':'Ethereal Light',
'moderate-normal-mild-severe-extremely-severe-high-avoidance':'Forest Haven',
'moderate-moderate-normal-mild-low-task':'Gentle Glow',
'moderate-moderate-normal-mild-low-emotional':'Spring Blossom',
'moderate-moderate-normal-mild-low-avoidance':'Snowy Crest',
'moderate-moderate-normal-mild-moderate-task':'Starry Cove',
'moderate-moderate-normal-mild-moderate-emotional':'Majestic Harbor',
'moderate-moderate-normal-mild-moderate-avoidance':'Quiet Grace',
'moderate-moderate-normal-mild-high-task':'Healing Tide',
'moderate-moderate-normal-mild-high-emotional':'Twilight Bloom',
'moderate-moderate-normal-mild-high-avoidance':'Clouded Path',
'moderate-moderate-moderate-low-task':'Velvet Shore',
'moderate-moderate-moderate-low-emotional':'Crimson Horizon',
'moderate-moderate-moderate-low-avoidance':'Dreaming Oasis',
'moderate-moderate-moderate-moderate-task':'Luminous Haven',
'moderate-moderate-moderate-moderate-emotional':'Golden Glow',
'moderate-moderate-moderate-moderate-avoidance':'Morning Whisper',
'moderate-moderate-moderate-high-task':'Havens Embrace',
'moderate-moderate-moderate-high-emotional':'Soulful Journey',
'moderate-moderate-moderate-high-avoidance':'Shaded Grove',
'moderate-moderate-severe-extremely-severe-low-task':'Harmony Blossom',
'moderate-moderate-severe-extremely-severe-low-emotional':'Serene Refuge',
'moderate-moderate-severe-extremely-severe-low-avoidance':'Tranquil Crest',
'moderate-moderate-severe-extremely-severe-moderate-task':'Restful Harbor',
'moderate-moderate-severe-extremely-severe-moderate-emotional':'Enchanted Path',
'moderate-moderate-severe-extremely-severe-moderate-avoidance':'Peaceful Glow',
'moderate-moderate-severe-extremely-severe-high-task':'Willow Haven',
'moderate-moderate-severe-extremely-severe-high-emotional':'Gentle Spirit',
'moderate-moderate-severe-extremely-severe-high-avoidance':'Sacred Bloom',
'moderate-severe-extremely-severe-normal-mild-low-task':'Radiant Harbor',
'moderate-severe-extremely-severe-normal-mild-low-emotional':'Bright Ascent',
'moderate-severe-extremely-severe-normal-mild-low-avoidance':'Whispering Breeze',
'moderate-severe-extremely-severe-normal-mild-moderate-task':'Echoing Ridge',
'moderate-severe-extremely-severe-normal-mild-moderate-emotional':'Kindred Haven',
'moderate-severe-extremely-severe-normal-mild-moderate-avoidance':'Mystic Whisper',
'moderate-severe-extremely-severe-normal-mild-high-task':'Golden Solace',
'moderate-severe-extremely-severe-normal-mild-high-emotional':'Ocean Haven',
'moderate-severe-extremely-severe-normal-mild-high-avoidance':'Harmony Tide',
'moderate-severe-extremely-severe-moderate-low-task':'Fallen Crest',
'moderate-severe-extremely-severe-moderate-low-emotional':'Blissful Stream',
'moderate-severe-extremely-severe-moderate-low-avoidance':'Morning Grace',
'moderate-severe-extremely-severe-moderate-moderate-task':'Ethereal Path',
'moderate-severe-extremely-severe-moderate-moderate-emotional':'Stillwater Cove',
'moderate-severe-extremely-severe-moderate-moderate-avoidance':'Radiant Bloom',
'moderate-severe-extremely-severe-moderate-high-task':'Windsong Harbor',
'moderate-severe-extremely-severe-moderate-high-emotional':'Sacred Glow',
'moderate-severe-extremely-severe-moderate-high-avoidance':'Velvet Horizon',
'moderate-severe-extremely-severe-severe-extremely-severe-low-task':'Crimson Mist',
'moderate-severe-extremely-severe-severe-extremely-severe-low-emotional':'Dreaming Glow',
'moderate-severe-extremely-severe-severe-extremely-severe-low-avoidance':'Twilight Whisper',
'moderate-severe-extremely-severe-severe-extremely-severe-moderate-task':'Luminous Path',
'moderate-severe-extremely-severe-severe-extremely-severe-moderate-emotional':'Clouded Solace',
'moderate-severe-extremely-severe-severe-extremely-severe-moderate-avoidance':'Snowy Haven',
'moderate-severe-extremely-severe-severe-extremely-severe-high-task':'Starry Crest',
'moderate-severe-extremely-severe-severe-extremely-severe-high-emotional':'Majestic Shore',
'moderate-severe-extremely-severe-severe-extremely-severe-high-avoidance':'Quiet Whisper',
'severe-extremely-severe-normal-mild-normal-mild-low-task':'Healing Bloom',
'severe-extremely-severe-normal-mild-normal-mild-low-emotional':'Peaceful Tide',
'severe-extremely-severe-normal-mild-normal-mild-low-avoidance':'Golden Spirit',
'severe-extremely-severe-normal-mild-normal-mild-moderate-task':'Shaded Harbor',
'severe-extremely-severe-normal-mild-normal-mild-moderate-emotional':'Soulful Blossom',
'severe-extremely-severe-normal-mild-normal-mild-moderate-avoidance':'Harmony Glade',
'severe-extremely-severe-normal-mild-normal-mild-high-task':'Serene Glow',
'severe-extremely-severe-normal-mild-normal-mild-high-emotional':'Willow Spirit',
'severe-extremely-severe-normal-mild-normal-mild-high-avoidance':'Tranquil Whisper',
'severe-extremely-severe-normal-mild-moderate-low-task':'Restful Bloom',
'severe-extremely-severe-normal-mild-moderate-low-emotional':'Enchanted Glow',
'severe-extremely-severe-normal-mild-moderate-low-avoidance':'Radiant Path',
'severe-extremely-severe-normal-mild-moderate-moderate-task':'Sacred Solace',
'severe-extremely-severe-normal-mild-moderate-moderate-emotional':'Bright Journey',
'severe-extremely-severe-normal-mild-moderate-moderate-avoidance':'Velvet Stream',
'severe-extremely-severe-normal-mild-moderate-high-task':'Ethereal Ridge',
'severe-extremely-severe-normal-mild-moderate-high-emotional':'Echoing Spirit',
'severe-extremely-severe-normal-mild-moderate-high-avoidance':'Kindred Path',
'severe-extremely-severe-normal-mild-severe-extremely-severe-low-task':'Mystic Ascent',
'severe-extremely-severe-normal-mild-severe-extremely-severe-low-emotional':'Golden Bloom',
'severe-extremely-severe-normal-mild-severe-extremely-severe-low-avoidance':'Ocean Solace',
'severe-extremely-severe-normal-mild-severe-extremely-severe-moderate-task':'Windsong Whisper',
'severe-extremely-severe-normal-mild-severe-extremely-severe-moderate-emotional':'Blissful Tide',
'severe-extremely-severe-normal-mild-severe-extremely-severe-moderate-avoidance':'Morning Spirit',
'severe-extremely-severe-normal-mild-severe-extremely-severe-high-task':'Stillwater Glow',
'severe-extremely-severe-normal-mild-severe-extremely-severe-high-emotional':'Peaceful Crest',
'severe-extremely-severe-normal-mild-severe-extremely-severe-high-avoidance':'Harmony Embrace',
'severe-extremely-severe-moderate-normal-mild-low-task':'Sacred Grace',
'severe-extremely-severe-moderate-normal-mild-low-emotional':'Fallen Stream',
'severe-extremely-severe-moderate-normal-mild-low-avoidance':'Bright Glow',
'severe-extremely-severe-moderate-normal-mild-moderate-task':'Whispering Spirit',
'severe-extremely-severe-moderate-normal-mild-moderate-emotional':'Golden Ridge',
'severe-extremely-severe-moderate-normal-mild-moderate-avoidance':'Radiant Journey',
'severe-extremely-severe-moderate-normal-mild-high-task':'Soulful Whisper',
'severe-extremely-severe-moderate-normal-mild-high-emotional':'Ocean Spirit',
'severe-extremely-severe-moderate-normal-mild-high-avoidance':'Harmony Glow',
'severe-extremely-severe-moderate-moderate-low-task':'Tranquil Embrace',
'severe-extremely-severe-moderate-moderate-low-emotional':'Luminous Stream',
'severe-extremely-severe-moderate-moderate-low-avoidance':'Dreaming Crest',
'severe-extremely-severe-moderate-moderate-moderate-task':'Velvet Glow',
'severe-extremely-severe-moderate-moderate-moderate-emotional':'Twilight Spirit',
'severe-extremely-severe-moderate-moderate-moderate-avoidance':'Healing Haven',
'severe-extremely-severe-moderate-moderate-high-task':'Serene Spirit',
'severe-extremely-severe-moderate-moderate-high-emotional':'Willow Blossom',
'severe-extremely-severe-moderate-moderate-high-avoidance':'Restful Tide',
'severe-extremely-severe-moderate-severe-extremely-severe-low-task':'Enchanted Spirit',
'severe-extremely-severe-moderate-severe-extremely-severe-low-emotional':'Radiant Whisper',
'severe-extremely-severe-moderate-severe-extremely-severe-low-avoidance':'Sacred Blossom',
'severe-extremely-severe-moderate-severe-extremely-severe-moderate-task':'Bright Spirit',
'severe-extremely-severe-moderate-severe-extremely-severe-moderate-emotional':'Shaded Haven',
'severe-extremely-severe-moderate-severe-extremely-severe-moderate-avoidance':'Golden Embrace',
'severe-extremely-severe-moderate-severe-extremely-severe-high-task':'Morning Bloom',
'severe-extremely-severe-moderate-severe-extremely-severe-high-emotional':'Stillwater Spirit',
'severe-extremely-severe-moderate-severe-extremely-severe-high-avoidance':'Ethereal Whisper',
'severe-extremely-severe-severe-extremely-severe-normal-mild-low-task':'Fallen Glow',
'severe-extremely-severe-severe-extremely-severe-normal-mild-low-emotional':'Echoing Spirit',
'severe-extremely-severe-severe-extremely-severe-normal-mild-low-avoidance':'Harmony Journey',
'severe-extremely-severe-severe-extremely-severe-normal-mild-moderate-task':'Mystic Haven',
'severe-extremely-severe-severe-extremely-severe-normal-mild-moderate-emotional':'Soulful Path',
'severe-extremely-severe-severe-extremely-severe-normal-mild-moderate-avoidance':'Golden Tide',
'severe-extremely-severe-severe-extremely-severe-normal-mild-high-task':'Ocean Glow',
'severe-extremely-severe-severe-extremely-severe-normal-mild-high-emotional':'Willow Whisper',
'severe-extremely-severe-severe-extremely-severe-normal-mild-high-avoidance':'Tranquil Spirit',
'severe-extremely-severe-severe-extremely-severe-moderate-low-task':'Peaceful Whisper',
'severe-extremely-severe-severe-extremely-severe-moderate-low-emotional':'Radiant Spirit',
'severe-extremely-severe-severe-extremely-severe-moderate-low-avoidance':'Serene Bloom',
'severe-extremely-severe-severe-extremely-severe-moderate-moderate-task':'Bright Whisper',
'severe-extremely-severe-severe-extremely-severe-moderate-moderate-emotional':'Sacred Spirit',
'severe-extremely-severe-severe-extremely-severe-moderate-moderate-avoidance':'Shaded Spirit',
'severe-extremely-severe-severe-extremely-severe-moderate-high-task':'Golden Path',
'severe-extremely-severe-severe-extremely-severe-moderate-high-emotional':'Stillwater Whisper',
'severe-extremely-severe-severe-extremely-severe-moderate-high-avoidance':'Blissful Whisper',
'severe-extremely-severe-severe-extremely-severe-severe-extremely-severe-low-task':'Luminous Spirit',
'severe-extremely-severe-severe-extremely-severe-severe-extremely-severe-low-emotional':'Dreaming Spirit',
'severe-extremely-severe-severe-extremely-severe-severe-extremely-severe-low-avoidance':'Velvet Spirit',
'severe-extremely-severe-severe-extremely-severe-severe-extremely-severe-moderate-task':'Echoing Whisper',
'severe-extremely-severe-severe-extremely-severe-severe-extremely-severe-moderate-emotional':'Solace Haven',
'severe-extremely-severe-severe-extremely-severe-severe-extremely-severe-moderate-avoidance':'Tranquil Bloom',
'severe-extremely-severe-severe-extremely-severe-severe-extremely-severe-high-task':'Bright Horizon',
'severe-extremely-severe-severe-extremely-severe-severe-extremely-severe-high-emotional':'Mystic Ridge',
'severe-extremely-severe-severe-extremely-severe-severe-extremely-severe-high-avoidance':'Haven Crest',
    // ... (all 243 combinations as provided)
  };

  return mappings[key] || 'Balanced Guardian';
};

// Helper function to get avatar index based on assessment results
export const getAvatarIndex = (
  depression: string,
  anxiety: string,
  stress: string,
  brs: string,
  ciss: 'task' | 'emotion' | 'avoidance'
): number => {
  // Standardize DASS levels
  const depLevel = standardizeLevels.dass[depression] || 'normal-mild';
  const anxLevel = standardizeLevels.dass[anxiety] || 'normal-mild';
  const strLevel = standardizeLevels.dass[stress] || 'normal-mild';
  
  // Standardize BRS level
  const brsLevel = standardizeLevels.brs[brs] || 'moderate';

  // Generate mapping key
  const key = `${depLevel}-${anxLevel}-${strLevel}-${brsLevel}-${ciss}`;
  
  // Map combinations to avatar indices (0-11 for 12 available avatars)
  const mappings: Record<string, number> = {
    'normal-mild-normal-mild-normal-mild-low-task': 0,
    'normal-mild-normal-mild-normal-mild-low-emotion': 1,
    'normal-mild-normal-mild-normal-mild-low-avoidance': 2,
    'normal-mild-normal-mild-normal-mild-moderate-task': 3,
    'normal-mild-normal-mild-normal-mild-moderate-emotion': 4,
    'normal-mild-normal-mild-normal-mild-moderate-avoidance': 5,
    'normal-mild-normal-mild-normal-mild-high-task': 6,
    'normal-mild-normal-mild-normal-mild-high-emotion': 7,
    'normal-mild-normal-mild-normal-mild-high-avoidance': 8,
    // ... (all 243 combinations mapped to 0-11)
  };

  return mappings[key] || 0;
};